export default {
	exportPrint: require("./export-print").default,
	export: require("./export").default,
};
